import { Text } from "@chakra-ui/react";
import { ConfirmationDialogProps } from "../Dialogs/ConfirmationDialog";

export const DefaultUnsavedChangesConfirmationDialogProps: Omit<
  ConfirmationDialogProps,
  "onCancel" | "onConfirm" | "isOpen"
> = {
  header: <Text fontSize="lg">Exit without saving?</Text>,
  body: (
    <Text>
      There are{" "}
      <Text as="span" fontWeight={600}>
        unsaved
      </Text>{" "}
      changes on this form. If you exit now, you will lose your changes.
    </Text>
  ),
  confirmButton: { label: "Exit without saving" },
};
